import React from 'react';
import BannerContactForm from './components/banner-contact-form';
import BannerInformation from './components/banner-information';
import { MainContainer, PageTitle } from './styles/page.styles';
import { ToastProvider } from './components/ui/toast';
import FormGlobalStyles from './components/FormGlobalStyles';

function ContactMarketingForm() {
  return (
    <MainContainer>
      <FormGlobalStyles />
      <ToastProvider>
        <PageTitle>광고 배너 임대 문의</PageTitle>
        <div className='grid-container'>
          <BannerInformation />
          <BannerContactForm />
        </div>
      </ToastProvider>
    </MainContainer>
  );
}

export default ContactMarketingForm;
